import i18n from 'scoreboard/components/i18n'
import ifOperators from './if-operators'

/**
 * @returns a list of options for the transformation-if operator select
 * options are placed in a specific order and grouped (#29852).
 * Some labels are different from the message code in their enum (either using
 * a different key, or having an ellipsis added to the end of the label)
 */

function ifOperatorOptions() {
	let combinedEnum = ifOperators.combinedEnum()

	let numbers = i18n.get('admin.import.transform.header.numbers')
	let text = i18n.get('admin.import.transform.header.text')
	let dates = i18n.get('admin.import.transform.header.dates')

	let options = [
		{
			id: 'is-blank',
			label: getLabel(combinedEnum['is-blank']),
			group: 'headerless'
		},
		{
			id: 'not-blank',
			label: getLabel(combinedEnum['not-blank']),
			group: 'headerless'
		},
		{
			id: 'is-any',
			label: getLabel(combinedEnum['is-any'], true),
			group: 'headerless'
		},
		{
			id: 'is-not-any',
			label: getLabel(combinedEnum['is-not-any'], true),
			group: 'headerless'
		},
		{
			id: 'less-than',
			label: getLabel('admin.import.transform.if.numeric.lessThan', true),
			group: numbers
		},
		{
			id: 'less-than-or-equals',
			label: getLabel('admin.import.transform.if.numeric.lessThanOrEquals', true),
			group: numbers
		},
		{
			id: 'greater-than',
			label: getLabel('admin.import.transform.if.numeric.greaterThan', true),
			group: numbers
		},
		{
			id: 'greater-than-or-equals',
			label: getLabel('admin.import.transform.if.numeric.greaterThanOrEquals', true),
			group: numbers
		},
		{
			id: 'between-number',
			label: getLabel('admin.import.transform.if.numeric.betweenNumbers', true),
			group: numbers
		},
		{
			id: 'is-number',
			label: getLabel(combinedEnum['is-number']),
			group: numbers
		},
		{
			id: 'is-not-number',
			label: getLabel(combinedEnum['is-not-number']),
			group: numbers
		},
		{
			id: 'contains-any',
			label: getLabel(combinedEnum['contains-any'], true),
			group: text
		},
		{
			id: 'contains-all',
			label: getLabel(combinedEnum['contains-all'], true),
			group: text
		},
		{
			id: 'does-not-contain-any',
			label: getLabel(combinedEnum['does-not-contain-any'], true),
			group: text
		},
		{
			id: 'does-not-contain-all',
			label: getLabel(combinedEnum['does-not-contain-all'], true),
			group: text
		},
		{
			id: 'begins-with',
			label: getLabel(combinedEnum['begins-with'], true),
			group: text
		},
		{
			id: 'ends-with',
			label: getLabel(combinedEnum['ends-with'], true),
			group: text
		},
		{
			id: 'does-not-begin-with',
			label: getLabel(combinedEnum['does-not-begin-with'], true),
			group: text
		},
		{
			id: 'does-not-end-with',
			label: getLabel(combinedEnum['does-not-end-with'], true),
			group: text
		},
		{
			id: 'character-length-is-any',
			label: getLabel(combinedEnum['character-length-is-any'], true),
			group: text
		},
		{
			id: 'character-length-is-not-any',
			label: getLabel(combinedEnum['character-length-is-not-any'], true),
			group: text
		},
		{
			id: 'character-length-less-than',
			label: getLabel(combinedEnum['character-length-less-than'], true),
			group: text
		},
		{
			id: 'character-length-greater-than',
			label: getLabel(combinedEnum['character-length-greater-than'], true),
			group: text
		},
		{
			id: 'character-length-between',
			label: getLabel(combinedEnum['character-length-between'], true),
			group: text
		},
		{
			id: 'matches-regular-expression',
			label: getLabel(combinedEnum['matches-regular-expression'], true),
			group: text
		},
		{
			id: 'before',
			label: getLabel(combinedEnum['before'], true),
			group: dates
		},
		{
			id: 'after',
			label: getLabel(combinedEnum['after'], true),
			group: dates
		},
		{
			id: 'between-date-time',
			label: getLabel('common.search.between.dates', true),
			group: dates
		},
		{
			id: 'on-any-date',
			label: getLabel(combinedEnum['on-any-date'], true),
			group: dates
		},
		{
			id: 'on-day-of-the-week',
			label: getLabel('admin.import.transform.if.dates.daysOfTheWeek', true),
			group: dates
		},
		{
			id: 'in-month-of-the-year',
			label: getLabel('admin.import.transform.if.dates.monthsOfTheYear', true),
			group: dates
		},
		{
			id: 'in-any-period',
			label: getLabel(combinedEnum['in-any-period'], true),
			group: dates
		},
		{
			id: 'not-in-any-period',
			label: getLabel(combinedEnum['not-in-any-period']),
			group: dates
		},
		{
			id: 'is-date',
			label: getLabel(combinedEnum['is-date']),
			group: dates
		},
		{
			id: 'is-not-date',
			label: getLabel(combinedEnum['is-not-date']),
			group: dates
		}
	]
	return options
}

// gets i18n message for key and adds an ellipsis if wanted
function getLabel(key, ellipsis) {
	let label = i18n.get(key)
	if (ellipsis) {
		label += '...'
	}
	return label
}

export default ifOperatorOptions
export { getLabel }
ifOperatorOptions.__filename__ = 'imports/transform/if-operator-options.js'
